
export interface ButtonProps {
    onclick: () => void
    loadingState?: boolean
    buttonText?: string
    className?:string
}


export const AppButtons = (props: ButtonProps) => {

    const {
        onclick,
        loadingState,
        buttonText,
        className
    } = props

    return (
        <>
            <div className="form-group ">
                {loadingState ?
                    <button disabled={true} className={className?className:"btn  btn-common spinner-button w-100"}>
                        <div className="spinner spinner_wave"></div>
                    </button> :
                    <button
                        disabled={loadingState}
                        type="button" className={className?className:"btn btn-common w-100 py-2 btn-green"}
                        onClick={onclick}>{buttonText}</button>

                }
            </div>
        </>
    )
}